export const overlayStyle = {
    position: 'fixed',
    inset: 0,
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    overflowY: 'auto',
    padding: '2rem 1rem',
};

export const dialogStyle = {
    backgroundColor: '#fff',
    padding: '1.5rem',
    width: '100%',
    maxWidth: '60rem',
    position: 'relative',
    borderRadius: '0.5rem',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
};

export const closeButtonStyle = {
    position: 'absolute',
    top: '0.75rem',
    right: '1rem',
    fontSize: '1.5rem',
    lineHeight: 1,
    background: 'none',
    border: 0,
    cursor: 'pointer',
};

export const infoGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(13rem, 1fr))',
    gap: '0.75rem 1.5rem',
    backgroundColor: '#f6f7f9',
    borderRadius: '0.5rem',
    padding: '1rem',
    margin: '1rem 0 1.5rem',
};

export const labelStyle = { fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.04em', color: '#777' };
export const valueStyle = { fontSize: '0.9rem', wordBreak: 'break-word' };

export const badgeStyle = (color) => ({
    display: 'inline-block',
    marginLeft: '0.5rem',
    padding: '0.1rem 0.6rem',
    fontSize: '0.75rem',
    fontWeight: 'normal',
    color: '#fff',
    backgroundColor: color,
    borderRadius: '1rem',
    verticalAlign: 'middle',
});
